import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import Table from './Table';
const Tab1 = ({ pageState, setPageState, taxes,handleChange}) => {
  return (
     <div>
      <div className="px-4 py-4" style={{ background: 'white' }}>

        <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>

              <div style={{ display: 'flex', gap: '15px', marginBottom: '-10px' }}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600', marginLeft: '2px' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <Input
            name="hsncode"
            label="HSN Code"
            style={{ height: "30px" }}
            value={pageState.hsncode}
                    onChange={(e) => handleChange('hsncode', e.target.value)}
          />
                </div>
                <div style={{ flex: 1 }}>
                   <Textarea
            style={{
              height: "38px",
              border: "",
            }}
            name='description'
            label="Description"
           value={pageState.description}
                    onChange={(e) => handleChange('description', e.target.value)}
          />

                </div>
                
                {/* <div style={{ flex: 1 }}>
                  
                </div> */}
                {/* <div style={{ flex: 1 }}>
                  
                </div> */}
              </div>







            </div>
          </div>

        </div>

       
    <div className="mb-3" style={{ display: 'flex', gap: '20px',border: '1px solid #DBDBDB', borderRadius: '5px' }} >

            <div className="col-md-12">
              <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
 <div style={{ display: 'flex', gap: '15px'}}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Tax Rates</p>
                </div>
              </div>
<Table taxes={{ value: pageState.taxes, setValue: (v) => setPageState({ ...pageState, taxes: v }) }} />

               




              </div>
            </div>

          </div>
        
      </div>
    </div>
  )
}

export default Tab1